import Table from "@/components/Table/table";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useClaimItemColumnDefs } from "./ClaimItemColumnDefination";
const Claim = ({ previewData }: { previewData: any }) => {
  const { caseId } = useParams();
  const colDefs = useClaimItemColumnDefs;

  const nav = useNavigate();

  const pinnedBottomRowData = (claim: any) => {
    return [
      {
        columnField1: <>Total</>,
        columnField2: <></>,
        columnField3: (
          <>{claim && claim?.claimItemTotalAmount?.totalOriginalAmt}</>
        ),
        columnField4: (
          <>{claim && claim?.claimItemTotalAmount?.totalCurrentAmt}</>
        ),
        columnField5: (
          <>
            {claim &&
              claim?.claimItemTotalAmount?.totalLatestCreditorPositionAmt}
          </>
        ),
        columnField6: (
          <>
            {claim && claim?.claimItemTotalAmount?.totalLatestDebtorPositionAmt}
          </>
        ),
        columnField7: (
          <>{claim && claim?.claimItemTotalAmount?.totalResolvedAmt}</>
        ),
      },
    ];
  };
  useEffect(() => {
    let tab = document?.getElementsByClassName("motif-table-title");
    for (let i = 0; i < tab?.length; i++) {
      let getClaimId =
        tab?.[i]?.parentElement?.parentElement?.parentElement?.getAttribute(
          "claimId"
        );
      if (getClaimId) {
        tab[i].className = "text-bold-underline motif-table-title";
        tab[i].setAttribute("style", "cursor:pointer");
        tab[i]?.addEventListener("click", function () {
          nav(`/case/${caseId}/claim/${getClaimId}`);
        });
      }
    }
  }, [previewData, nav, caseId]);

  return (
    <div className="claim_item_table">
      {previewData?.map((claim: any, index: number) => (
        //@ts-ignore
        <div className="mar-b-20" key={index} claimId={claim.claimId}>
          <Table
            columnDefs={colDefs(caseId, claim.claimId, claim.claimReference)}
            cellRenderers={claim && claim?.claimItems}
            TitleComplement={() => <></>}
            title={`Claim ID ${claim.claimReference}`}
            description={`Claim item list for claim ref ${claim.claimReference}`}
            // caseRenderers={caseRenderers(claim.claimId,claim.claimReference,caseId)}
            pagination={false}
            pinnedBottomRowData={
              claim?.claimItems && claim?.claimItems.length > 0
                ? pinnedBottomRowData(claim)
                : null
            }
          />
        </div>
      ))}
    </div>
  );
};
export default Claim;
